import React, { Component } from "react";
import { Link } from "react-router-dom";
import { request } from "../utils/request";
import { AppContext } from "../utils/context";
import { formatCurrency } from "../utils/constants";
import RemainingCardsEnvelopes from "../components/RemainingCardsEnvelopes";
import AddonEventWinnerList from "../components/AddonEventWinnerList";

const EnvelopeDetails = (props) => {
    let card = props?.draw?.card ?? null;
    if (card) return (
        <div>
            <span className="inline md:hidden font-bold">
            {`${props.localLanguage.general_card}: `}
            </span>
            {card.suit === "D" ? (
            <span style={{ color: "red" }}>
                &diams;
            </span>
            ) : (
                ""
            )}
            {card.suit === "H" ? (
            <span style={{ color: "red" }}>
                &hearts;
            </span>
            ) : (
                ""
            )}
            {card.suit === "S" ? (
            <span>&spades;</span>
            ) : (
                ""
            )}
            {card.suit === "C" ? (
            <span>&clubs;</span>
            ) : (
                ""
            )}
            {card.suit === "RJ" ? (
            <span style={{ color: "red" }}>
                &#x1F0DF; {props.localLanguage.general_red_joker}
            </span>
            ) : (
                ""
            )}
            {card.suit === "BJ" ? (
            <span>&#x1F0CF; {props.localLanguage.general_black_joker}</span>
            ) : (
                ""
            )}
            {card.suit !== "RJ" && card.suit !== "BJ" &&
            ` ${props.localLanguage.general_suit_in_envelope.replace("{card.rank}", card.rank).replace("{envelopeNumber}", card.envelope)}`}
        </div>
    )
    return null;
}

class Winners extends Component {
  state = { winners: [], isEmptyState: false };
  componentDidMount = () => {
    return request.get("api:/web/winners", {}).then(resp => {
      this.setState({
        winners: resp.data
      });
    });
  };

  render() {
    const { winners } = this.state;
    const { localLanguage, settings } = this.context;
    let columnStyle = settings.winners_name_settings === 'disabled' ? "w-full md:w-1/4 text-accent px-2" : "w-full md:w-1/5 text-accent px-2"
    let textStyle = settings.winners_name_settings === 'disabled' ? "w-full md:w-1/4 px-2" : "w-full md:w-1/5 px-2"

    return (
      <div className={`container mx-auto py-6 winnersPage`}>
        <h1 className="mb-6 text-accent">{localLanguage.general_winners}</h1>
        {winners && winners.map((v, k) => (
          <div key={`eventSelection${k}`}>
            <div className="block mx-auto my-4 overflow-hidden rounded-lg no-underline bg-accent">
                <div className="flex items-center justify-center px-6 py-4">
                    <div className="md:w-1/3"></div>
                    <div className="md:w-1/3 text-center">
                        <span className="font-bold text-white text-xl">
                            {localLanguage[`general_game_${v.game.id}_title`]}
                        </span>
                    </div>
                    <div className="md:w-1/3 text-center">
                        {v.game_id === 3 && (
                            <RemainingCardsEnvelopes event={v.threads[0]} settings={settings} isWinnersPage={true} />
                        )}
                    </div>
                </div>

              <div className="hidden md:flex flex-wrap bg-secondary font-bold py-4">
                <div className={columnStyle} style={{textAlign:"center"}}> {localLanguage.general_date} </div>
                <div className={columnStyle} style={{textAlign:"center"}}> {localLanguage.general_event} </div>
                <div className={columnStyle} style={{textAlign:"center"}}> {localLanguage.general_results}</div>
                <div className={columnStyle} style={{textAlign:"center"}}> {localLanguage.general_win_num} </div>
                {settings.winners_name_settings != 'disabled' && (<div className={columnStyle} style={{textAlign:"center"}}> {localLanguage.general_winner_name} </div>)}

              </div>
              {v.threads.map(t => {
                if (t.draws.length === 0 && !v.addon_events) return null; // check for null data
                if (t.draws.length === 0 && v.addon_events) {
                  return <AddonEventWinnerList key={`addon-row-1`} event = {v} thread={t} index= {null} showMainEventTitle = {true}/>
                }
                return t.draws.map((d, i) => {
                  return (
                    <div
                    key={`winner-row-${i}`}
                      className={
                        Number.isInteger(i / 2)
                          ? "flex flex-wrap bg-grey-lighter py-4"
                          : "flex flex-wrap bg-white py-4"
                      }
                    >
                      <div className={textStyle} style={{textAlign:"center"}}>
                        <span className="inline md:hidden font-bold">
                          {localLanguage.general_date}:{" "}
                        </span>
                        {d.draw_at}
                      </div>

                      <div className={textStyle} style={{textAlign:"center"}}>
                        <span className="inline md:hidden font-bold">
                          {localLanguage.general_event}:{" "}
                        </span>
                        {t.title}
                      </div>

                      <div className={textStyle} style={{textAlign:"center"}}>
                      {v.game.id === 1 && (
                          <div>
                            {+settings.show_jackpot_on_winners_page === 1 && !d.is_secondary && (
                              <span className="inline font-bold">
                                {localLanguage.general_jackpot}:{" "}
                              </span>
                            )}
                            {+settings.show_jackpot_on_winners_page === 1 && !d.is_secondary && formatCurrency(Math.floor(+d.jackpot))}
                          </div>
                        )}
                        {+settings.show_weekly_jackpot === 1 && (
                          <span className="inline font-bold">
                            {v.game_id === 2 ? `${localLanguage.general_prize}: ` :
                                d.is_secondary ? `${d.title}` :
                                    `${d.title}: `}
                          </span>
                        )}
                        {v.game_id === 2 ? d.title :
                            d.is_secondary ? '' :
                                (d.winning_card && !t.draws[1] ?
                                    formatCurrency(Math.floor(+d.jackpot)) :
                                    (+settings.show_weekly_jackpot === 1 ?
                                        formatCurrency(Math.floor(t.thread_is_final && d.is_grand ? +d.jackpot : +d.prize)) : ""
                                    )
                                )
                        }
                        {v.game.id === 3 && d.winning_card && !t.draws[1] && (
                          <div>
                            {+settings.show_weekly_jackpot === 1 && (
                              <span className="inline font-bold">
                                {localLanguage[`game_${v.game.id}_prize_title`]}:{" "}
                              </span>
                            )
                            }
                            {+settings.show_weekly_jackpot === 1 && formatCurrency(Math.floor(+d.prize))}
                          </div>
                        )}
                        {t.thread_is_final && d.winning_card ? (
                            <div className="text-xs italic mt-1">
                                <Link to='/rules'>
                                    {localLanguage.general_see_rules_final_draw.replace("{final_draw_rules}", localLanguage[`game_${v.game.id}_final_draw`])}
                                </Link>
                            </div>) :
                            ""}
                      </div>

                      <div className={textStyle} style={{textAlign:"center"}}>
                        <span className="inline md:hidden font-bold">
                          {localLanguage.general_win_num}:{" "}
                        </span>
                        {d.number}
                        {(!t.thread_is_final || !d.is_grand || (t.thread_is_final && d.is_grand)) && d.card && (
                          <EnvelopeDetails draw={d} localLanguage={localLanguage} />
                        )}
                      </div>
                      {settings.winners_name_settings != 'disabled' && 
                      (<div className={textStyle} style={{textAlign:"center"}}>
                        <span className="inline md:hidden font-bold">
                        {localLanguage.general_winner_name}:{" "}
                        </span>
                         {d.formatted_winners_name}
                      </div>)}
                      <AddonEventWinnerList key={`addon-row-1`} event = {v} settings={settings} thread={t} index= {i} showMainEventTitle = {false}/>
                    </div>
                  )
                })
              })}
              <div className="flex justify-around  bg-primary text-base">
                <div
                  className="flex items-center leading-normal bg-secondary border-secondary rounded m-4 whitespace-no-wrap text-white font-semibold"
                >
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}
Winners.contextType = AppContext;

export default Winners;
